import { PartIdentifier } from "./PartIdentifier";
import { buildProductionMethod } from "./CostStudyBuilder";

export class LogisticsCostKey {
  /**
   *
   * @param {{partId:string, recievingPlantNumber:string, productionMethodName:string}} key1d
   * @param {{partId:string, recievingPlantNumber:string, productionMethodName:string}} key2d
   * @returns {bool}
   */
  static compare = (key1, key2) => {
    return (
      PartIdentifier.compare(key1.partId, key2.partId) &&
      key1.manufacturingPlantNumber === key2.manufacturingPlantNumber &&
      key1.recievingPlantNumber === key2.recievingPlantNumber &&
      key1.productionMethodName === key2.productionMethodName
    );
  };

  // ATTN: isn't getting the partId
  static buildKeyFromBomComponent = (component) => {
    let productionMethod = component.productionMethod;
    let recievingPlantNumber =
      productionMethod.value && productionMethod.value.receivingPlant.value
        ? productionMethod.value.receivingPlant.value.plantNumber
        : "";
    let productionMethodName = productionMethod.value
      ? productionMethod.value.method
      : "";
    let manufacturingPlantNumber =
      productionMethod.value.manufacturingPlant.value.plantNumber &&
      productionMethod.value.manufacturingPlant.value
        ? productionMethod.value.manufacturingPlant.value.plantNumber
        : "";
    return {
      partId: component.partId,
      productionMethodName,
      manufacturingPlantNumber,
      recievingPlantNumber,
    };
  };

  static buildKeyFromLogistics = (logistics) => {
    let productionMethod = buildProductionMethod(logistics.ProductionMethod);
    let recievingPlantNumber = productionMethod.receivingPlant
      ? productionMethod.receivingPlant.plantNumber
      : "";
    let manufacturingPlantNumber = productionMethod.manufacturingPlant
      ? productionMethod.manufacturingPlant.plantNumber
      : "";
    let productionMethodName = productionMethod.method;
    return {
      partId: PartIdentifier.buildPartIdentifier(logistics.Part),
      productionMethodName,
      manufacturingPlantNumber,
      recievingPlantNumber,
    };
  };
}
